export default "dist/images/block-call-to-action-horizontal-3.7796d9f.png";